import React from 'react';
import { MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="w-full py-8 md:py-12 px-6 mt-12 md:mt-20 border-t border-white/10 glass-panel" data-id="element-23">
      <div className="w-full max-w-md md:max-w-2xl mx-auto flex flex-col items-center text-center space-y-4 md:space-y-6" data-id="element-24">
        <div className="flex items-center text-white/60 text-sm md:text-base font-inter" data-id="element-25">
          <MapPin className="w-4 h-4 md:w-5 md:h-5 mr-2 text-accent-cyan" data-id="element-26" />
          <span data-id="element-27">Downtown Toronto • Toronto, ON, Canada</span>
        </div>
        <p className="font-sora font-semibold text-base md:text-lg lg:text-xl text-transparent bg-clip-text bg-gradient-to-r from-accent-cyan via-accent-purple to-accent-pink" data-id="element-28">
          This is where capital meets connection.
        </p>
      </div>
    </footer>;
}